import i18n from "../../language/i18n";

export default i18n;
